import script from "./PhysicalScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PhysicalScanner.vue?vue&type=script&setup=true&lang=js"

import "./PhysicalScanner.vue?vue&type=style&index=0&id=b0f78f38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0f78f38"]])

export default __exports__